import {tns} from 'tiny-slider/src/tiny-slider';

export const initPropertySlider = () => {
  for (const slider of document.getElementsByClassName('property-display__slider-container')) {

    const sliderContainer = slider.getElementsByClassName('property-display__slider')[0];

    if (!sliderContainer || sliderContainer.length === 0) {
      return;
    }

    const autoplay = document.getElementById('auto-scroll-flag') !== null;

    const tinyslider = tns({
      container: sliderContainer,
      autoplay,
      autoplayButtonOutput: false,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      items: 1,
      controls: true,
      mouseDrag: false,
      loop: true,
      nav: false,
      lazyload: true,
      controlsContainer: slider.getElementsByClassName('property-display__slider__controls-container')[0]
    });

    slider.style.height = 'auto';
  }
};
